module.exports = __webpack_public_path__ + "static/media/circle.812a2438.svg";